<template>
    <div class="page">
        <div style="height: 100%" ref="chart"></div>
        <div class="b" v-show="bShow" :style="{ top: (bT - 150) + 'px', left: bL + 'px' }">
            <span>总运单量: {{ zydl }}单</span>
            <span>总运单金额: {{ ((parseInt(zydje) / 10000).toFixed(2)) }}万</span>
            <span>已结算单量: {{ yjsdl }}单</span>
            <span>已结算金额: {{ ((parseInt(yjsje) / 10000)).toFixed(2) }}万</span>
            <span>未结算单量: {{ wjsdl }}单</span>
            <span>未结算金额: {{ ((parseInt(wjsje) / 10000)).toFixed(2) }}万</span>
            <span class="tc1">应收款: {{ ((parseInt(ysMoney) / 10000)).toFixed(2) }}万</span>
            <span class="tc1">已收款: {{ ((parseInt(yishoukuan) / 10000)).toFixed(2) }}万</span>
            <span class="tc1">未收款: {{ ((parseInt(wsMoney) / 10000)).toFixed(2) }}万</span>
        </div>
        <el-dialog center :visible.sync="cwShow" width="50%" @close="renderData()">
            <div class="tabTitle">财务信息</div>
            <el-form v-show="isShowDate" style="padding-left: 50px" :inline="true" class="demo-form-inline">
                <el-form-item label="月份">
                    <el-date-picker
                        style="width：200px"
                        v-model="addParams.month"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="应收款" style="opacity: 0;">
                    <el-input v-model="addParams.ysMoney"></el-input>
                </el-form-item>
                <el-form-item style="opacity: 0;">
                    <el-button type="primary" style="background: #00A0E9;border-color: #00A0E9;">新 建</el-button>
                </el-form-item>
            </el-form>
            <el-form style="padding-left: 50px" :inline="true" class="demo-form-inline">
                <el-form-item label="线路">
                    <el-select v-model="addParams.roadId">
                        <el-option v-for="item in roadList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应收款">
                    <el-input v-model="addParams.ysMoney"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="background: #00A0E9;border-color: #00A0E9;"
                               @click="toFinancialAdd()">新 建
                    </el-button>
                    <el-button v-show="!isShowDate" type="success" @click="toExport(statementList)">导 出</el-button>
                </el-form-item>
            </el-form>
            <el-form style="padding-left: 50px" :inline="true" class="demo-form-inline">
                <el-form-item label="开票">
                    <el-input v-model="addParams.billing"></el-input>
                    <!-- <el-select v-model="addParams.billing">
                        <el-option label="未开票" :value="false"></el-option>
                        <el-option label="已开票" :value="true"></el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="已收款">
                    <el-input v-model="addParams.wsMoney"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="background: #EA5B24;border-color: #EA5B24;"
                               @click="toFinancialDel">删 除
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-show="!isShowDate"
                :data="statementList"
                style="width: 99.9%"
                ref="tab"
                @select="selectionChange">
                <el-table-column header-align="center" align="center" type="selection"></el-table-column>
                <el-table-column header-align="center" align="center" label="线路">
                    <template slot-scope="data">
                        <el-select v-if="data.row.selectd" style="width: auto;" v-model="data.row.roadId">
                            <el-option v-for="item in roadList" :key="item.value" :label="item.label"
                                       :value="item.value"></el-option>
                        </el-select>
                        <span v-else>{{ data.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="应收款">
                    <template slot-scope="data">
                        <el-input v-if="data.row.selectd" v-model="data.row.ysMoney"></el-input>
                        <span v-else>{{ data.row.ysMoney }}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="开票">
                    <template slot-scope="data">
                        <el-input v-if="data.row.selectd" v-model="data.row.billing"></el-input>
                        <span v-else>{{ data.row.billing }}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="已收款">
                    <template slot-scope="data">
                        <el-input v-if="data.row.selectd" v-model="data.row.wsMoney"></el-input>
                        <span v-else>{{ data.row.wsMoney }}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="未收款">
                    <template slot-scope="data">
                        <el-input disabled v-if="data.row.selectd"
                                  :value="data.row.ysMoney - data.row.wsMoney"></el-input>
                        <span v-else>{{
                                isNaN(data.row.ysMoney - data.row.wsMoney) ? 0 : Number(data.row.ysMoney - data.row.wsMoney).toFixed(2)
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column width="50px" v-if="isSelectd" header-align="center" align="center">
                    <el-button slot-scope="data" v-if="data.row.selectd" type="text" size="small"
                               @click="save(data.row)">保存
                    </el-button>
                </el-table-column>
            </el-table>
            <div slot="footer">
                <el-button class="btn c1" type="primary" @click="cwShow=false">保存</el-button>
                <el-button class="btn c2" @click="cwShow=false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog
            center
            :visible.sync="sjShow"
            width="60%">
            <div class="tabTitle">数据详情</div>
            <el-table
                :data="statementList2"
                style="width: 99.9%">
                <el-table-column header-align="center" align="center" label="线路">
                    <span slot-scope="data">{{ data.row.startLocation }} - {{ data.row.targetLocation }}</span>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="zfcl" label="总发车量"></el-table-column>
                <el-table-column header-align="center" align="center" prop="je" label="金额"></el-table-column>
                <el-table-column header-align="center" align="center" prop="yjsdl" label="已结算单量"></el-table-column>
                <el-table-column header-align="center" align="center" prop="yjsje" label="已结算金额"></el-table-column>
                <el-table-column header-align="center" align="center" prop="wjsdl" label="未结算单量"></el-table-column>
                <el-table-column header-align="center" align="center" prop="wjsje" label="未结算金额"></el-table-column>
            </el-table>
        </el-dialog>
        <el-button class="cwBtn" @click="getList(true, true)">添 加</el-button>
        <el-button class="download" type="primary" @click="downloadExport">导出</el-button>
        <el-select class="download2" size="small" style="width: 100px" v-model="year"
                   @change="renderData" placeholder="请选择">
            <el-option v-for="item in yearsList" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
import config from './config/report.config'
import {road} from '@/api/public'
import {export_json_to_excel} from "@/utils/Export2Excel";
import {
    statementBb,
    statementPage,
    financialAdd,
    financialDel,
    financialEdit,
    statementDetail,
    statementExport
} from '@/api/finance'
import * as echarts from 'echarts';

export default {
    data() {
        return {
            year: null,
            yearsList: [],
            isShowDate: false,
            roadList: [],
            cwShow: false,
            sjShow: false,
            bShow: false,
            bL: 0,
            bT: 0,
            bbData: [],
            statementList: [],
            statementList2: [],
            zydl: 0,
            zydje: 0,
            yjsdl: 0,
            yjsje: 0,
            wjsdl: 0,
            wjsje: 0,
            ysMoney: 0,
            wsMoney: 0,
            yishoukuan: 0,
            addParams: {
                roadId: '',
                ysMoney: '',
                billing: '',
                wsMoney: '',
                month: ''
            },
            roles: {},
            ...config()
        }
    },
    created() {
        this.initYears();
        this.createConfig();
        let _roleStr;
        let _role = {};
        for (let i = 0; i < this.$route.matched.length; i++) {
            const item = this.$route.matched[i];
            if (item.meta && item.meta.role) _roleStr = item.meta.role;
            if (item.path === this.$route.path) break;
        }
        console.log(_roleStr)
        if (_roleStr)
        _roleStr.split(',').forEach(item => _role[item] = true);
        this.roles = _role;
    },
    computed: {
        isSelectd() {
            let _statu = false;
            this.statementList.forEach(item => {
                if (item.selectd) _statu = true;
            })
            return _statu;
        }
    },
    methods: {
        //设置日期列表
        initYears() {
            let nowDate = new Date;
            let year = nowDate.getFullYear();//获取当前年
            this.year = year
            let size = year - 2019
            for (let i = 0; i < size; i++) {
                this.yearsList.push({value: (year - i), label: (year - i) + "年"});
            }
        },
        toExport(list) {
            const excelHeader = ['路线', '应收款', '开票', '已收款', '未收款'];
            const excelData = []
            list.forEach(item => {
                const _arr = [
                    `${item.startLocation} - ${item.targetLocation}`,
                    item.ysMoney,
                    item.billing,
                    item.wsMoney,
                    isNaN(item.ysMoney - item.wsMoney) ? 0 : Number(item.ysMoney - item.wsMoney).toFixed(2)
                ];
                excelData.push(_arr);
            })
            console.log(excelData);
            export_json_to_excel(excelHeader, excelData, '财务信息' + Date.now())
        },
        downloadExport() {
            statementExport(this.year).then(res => {
                let blob = new Blob([res.data], {type: res.data.type})
                let downloadElement = document.createElement('a')
                let href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = `财务报表-${Date.now()}.xlsx`;
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                document.body.removeChild(downloadElement); //下载完成移除元素
                window.URL.revokeObjectURL(href); //释放blob对象
            });
        },
        save(row) {
            financialEdit(row).then(res => {
                this.getList(false);
                this.$refs.tab.toggleRowSelection(row);
            })
        },
        getStatementDetail(month) {
            statementDetail({month}).then(res => {
                this.statementList2 = res.data;
            })
        },
        toFinancialDel() {
            const ids = this.$refs.tab.selection.map(item => item.id);
            financialDel(ids).then(res => {
                this.getList(false);
            })
        },
        selectionChange(list, row) {
            row.selectd = !row.selectd;
        },
        toFinancialAdd() {
            financialAdd(this.addParams).then(res => {
                if (this.isShowDate) {
                    this.cwShow = false;
                } else {
                    this.getList();
                }
            })
        },
        createConfig() {
            Promise.all([road()]).then(([road]) => {
                this.roadList = road.data.map(item => ({...item, label: item.name, value: item.roadId}));
                console.log(road)
                this.searchConfig = this.createSearch(this.roadList);
            })
        },
        handleBtn(key, list) {
            if (list.length !== 1) this.$error('请选择一项操作');
            if (key === 'submit') {
                this.submitConfig = this.createSubmit();
            } else {
                this.rejectConfig = this.createReject();
            }
            this.$refs[key].open(null, {planId: list[0].planId})
        },
        getList(boolean = true, boo2 = false) {
            this.isShowDate = boo2;
            if (this.isShowDate) {
                this.addParams.month = ''
                this.statementList = []
            }
            if (boolean) {
                this.addParams.roadId = '';
                this.addParams.ysMoney = '';
                this.addParams.billing = '';
                this.addParams.wsMoney = '';
            }
            if (this.addParams.month) {
                statementPage({month: this.addParams.month}).then(res => {
                    res.data.forEach(item => {
                        item.selectd = false;
                    });
                    this.statementList = res.data;
                    this.cwShow = true;
                })
            } else {
                this.cwShow = true;
            }
        },
        renderCanvas() {
            const myChart = echarts.init(this.$refs.chart);
            const _xData = [];
            const _yData1 = [];
            const _yData2 = [];
            const _yData3 = [];
            const _yData4 = [];
            for (let i = 0; i < this.bbData.length; i++) {
                const item = this.bbData[i];
                _xData.push(item.date)
                _yData1.push(item.yjsje)
                _yData2.push(item.wjsje)

                const _num1 = isNaN(item.ysMoney) ? 0 : Number(item.ysMoney)
                const _num2 = isNaN(item.wsMoney) ? 0 : Number(item.wsMoney)

                // 已收款
                _yData3.push(item.wsMoney);
                // 未收款
                _yData4.push(_num1 - _num2)
            }
            const option = {
                legend: {
                    data: ['已结算单量/已结算金额', '未结算单量/未结算金额', '已收款', '未收款']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: _xData
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '已结算单量/已结算金额',
                        type: 'bar',
                        stack: '结算',
                        itemStyle: {color: '#163C78'},
                        emphasis: {focus: 'series'},
                        data: _yData1
                    },
                    {
                        name: '未结算单量/未结算金额',
                        type: 'bar',
                        stack: '结算',
                        itemStyle: {color: '#6F87AC'},
                        emphasis: {focus: 'series'},
                        data: _yData2
                    },
                    {
                        name: '已收款',
                        type: 'bar',
                        stack: '收款',
                        itemStyle: {color: '#228D47'},
                        emphasis: {focus: 'series'},
                        data: _yData3
                    },
                    {
                        name: '未收款',
                        type: 'bar',
                        stack: '收款',
                        itemStyle: {color: '#76B88F'},
                        emphasis: {focus: 'series'},
                        data: _yData4
                    },

                ]
            };
            myChart.setOption(option);
            myChart.on('click', params => {
                if (params.seriesName === '已收款' || params.seriesName === '未收款') {
                    // if (!this.roles.Finance_Statement_ADD) return;
                    this.addParams.month = params.name;
                    this.getList();
                } else if (params.seriesName === '已结算单量/已结算金额') {
                    this.getStatementDetail(params.name)
                    this.sjShow = true;
                }
            });
            myChart.on('mouseover', params => {
                // if (params.seriesName === '应收款') {}
                this.bT = params.event.offsetY;
                this.bL = params.event.offsetX;
                this.bbData.forEach(item => {
                    if (item.date == params.name) {
                        this.zydl = isNaN(item.zydl) ? 0 : Number(item.zydl)
                        this.zydje = isNaN(item.zydje) ? 0 : Number(item.zydje)
                        this.yjsdl = isNaN(item.yjsdl) ? 0 : Number(item.yjsdl)
                        this.yjsje = isNaN(item.yjsje) ? 0 : Number(item.yjsje)
                        this.wjsdl = isNaN(item.wjsdl) ? 0 : Number(item.wjsdl)
                        this.wjsje = isNaN(item.wjsje) ? 0 : Number(item.wjsje)
                        this.ysMoney = isNaN(item.ysMoney) ? 0 : Number(item.ysMoney)
                        const _num1 = isNaN(item.ysMoney) ? 0 : Number(item.ysMoney)
                        const _num2 = isNaN(item.wsMoney) ? 0 : Number(item.wsMoney)
                        this.wsMoney = _num1 - _num2;
                        this.yishoukuan = isNaN(item.wsMoney) ? 0 : Number(item.wsMoney);
                    }
                })
                this.bShow = true;
            });
            myChart.on('mouseout', (params) => {
                if (params.seriesName === '应收款') {
                }
                this.bShow = false;
            });

        },
        renderData() {
            statementBb({year: this.year}).then(res => {
                this.bbData = res.data;
                this.renderCanvas()
            })
        }
    },
    mounted() {
        this.renderData();
    }
}
</script>

<style lang="less" scoped>
.el-date-editor {
    width: 200px;
}

.cwBtn {
    position: absolute;
    right: 2%;
    bottom: 0;
    padding: 0 17px;
    min-width: 78px;
    box-sizing: border-box;
    height: 30px;
    background: #EA5B24;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
}

.el-select {
    width: 200px;
}

/deep/ .el-form-item {
    margin-right: 50px;
}

/deep/ .el-dialog__body {
    padding: 25px 0 30px;
}

.page {
    position: relative;
    height: 100%;
}

.b {
    position: absolute;
    background: #000000;
    border-radius: 5px;
    color: #FFFFFF;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 11px 13px;
    line-height: 25px;
    justify-content: center;

    .tc1 {
        color: #228D47;
    }
}

.btn {
    padding: 0 17px;
    min-width: 78px;
    box-sizing: border-box;
    height: 30px;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
}

.c1 {
    background: #163C78;
    margin-right: 90px;
}

.c2 {
    background: #BFBFBF;
}

.tabTitle {
    width: 100px;
    height: 33px;
    background: rgba(22, 60, 120, 0.2);
    margin-bottom: 20px;
    border-radius: 0px 3px 3px 0px;
    text-align: center;
    line-height: 33px;
    font-size: 14px;
    color: #163C78;
    font-weight: bold;
}

.download {
    position: absolute;
    right: 0;
    top: 0;
}

.download2 {
    position: absolute;
    right: 120px;
    top: 0;
}
</style>
